import type { ChatUIState } from '@packages/types';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState: ChatUIState = {
    isCollapsed: false,
    title: '',
    fullPath: '',
    latestDocumentId: '',
    stopTraffic: false,
};

const chatSlice = createSlice({
    name: 'chat/ui',
    initialState,
    reducers: {
        setCollapsed(state, { payload }: PayloadAction<boolean>) {
            state.isCollapsed = payload;
        },
        setTitle(state, { payload }: PayloadAction<string>) {
            state.title = payload;
        },
        setFullPath(state, { payload }: PayloadAction<string>) {
            state.fullPath = payload;
        },
        setLatestDocumentId(state, { payload }: PayloadAction<string>) {
            state.latestDocumentId = payload;
        },
        setStopTraffic(state, { payload }: PayloadAction<boolean>) {
            state.stopTraffic = payload;
        },
    },
});

export const { setCollapsed, setTitle, setFullPath, setLatestDocumentId, setStopTraffic } = chatSlice.actions;
export default chatSlice.reducer;
